module.exports = __webpack_public_path__ + "static/media/account.2046973d.svg";